import { calculateDiscountedPrice } from '../shared/utils/discounts';
import { Offer } from '../types';
import { KeyboardEvent } from 'react';
import { REGISTERED_APPS } from '../shared/types/Apps';

function convertPresentmentCurrency(amount: number, amount_type?: string) {
  if (amount < 0) return 0;

  if (amount_type === 'fixed_amount') {
    return amount * Number(window.Shopify.currency.rate);
  }
  return amount;
}

const handleConfirmation = (cb: any) => (e: KeyboardEvent<HTMLDivElement>) => {
  if (e.key === 'Enter') {
    cb && cb();
  }
};

function getDiscountedPrice(
  offer: Partial<Offer>,
  variant: any,
  quantity: number,
  app?: REGISTERED_APPS,
) {
  const { amount_type, amount, apply_discount } = offer;

  const variantPrice = (variant.price * quantity) / 100;

  return calculateDiscountedPrice(
    variantPrice,
    convertPresentmentCurrency(Number(amount), amount_type),
    amount_type,
    apply_discount,
    app,
  );
}

export { getDiscountedPrice, handleConfirmation };
